export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-12.jpg'),
        title: 'デジタル変革',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'デジタル革命はパラダイムの完全な転換です',
      description: `<p style="font-size:1.05rem">技術の進展により世界は大きく変化しており、業種に関わらず最新技術に対応することが成功の鍵となっています。工業革命と同様に、デジタル革命はパラダイムの転換をもたらします。AI、IoT、ブロックチェーン、ビッグデータなどの新技術は単なるキーワードではなく、ビジネスを含む私たちの生活のあらゆる側面に不可欠な要素になっています。デジタル化は企業の運営方法、予測手法、製品の販売方法を変革し、今日のデジタルなグローバル経済に取り残されないことを可能にします。</p><p>MaesInfoは貴社のITソリューションにとって頼れるパートナーとなれます。MaesInfoのコンサルタントはフォーチュン500企業を含む多くの業界で企業向けにカスタマイズされた包括的なソリューションを提供してきました。ソフトウェアエンジニアリングの豊富な経験を活かし、デジタル時代に備えるお手伝いをします。サービスのデジタル化、電子商取引支援、ソフトウェア開発や統合のいずれが必要でも、適切なITソリューションを提供します。</p>`
    },
    {
      title: '​​MaesInfoは幅広いソリューションを提供し、品質とコスト効果の高い導入に注力します：',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-12.jpg')+`)"></span>
      <span class="list">
      <i></i>企業のITインフラ整備<br/>
      <i></i>サービスのデジタル化<br/>
     <i></i>ビジネス支援

      </span>`
    }
  ]
}
